import {
  GroupPermission,
  GroupScope,
  GroupType,
  GroupTypeRoleSelection,
} from '../types/group';
import { BulkPermissionGrant } from '../types/permissions';

export function buildScopeMapFromGroupTypes(
  international: GroupType[],
  spd: GroupType[],
  local: GroupType[]
): Map<string, GroupScope> {
  const map = new Map<string, GroupScope>();
  for (const gt of international) map.set(gt.id, 'international');
  for (const gt of spd) map.set(gt.id, 'spd_chapter');
  for (const gt of local) map.set(gt.id, 'local_chapter');
  return map;
}

export function permissionToSelection(
  perm: GroupPermission,
  scope: GroupScope
): GroupTypeRoleSelection {
  return {
    scope,
    group_type_id: perm.group_type_id,
    all_roles: perm.all_roles,
    role_ids: perm.all_roles ? [] : [...(perm.role_ids || [])],
  };
}

export function selectionToPermission(
  sel: GroupTypeRoleSelection
): GroupPermission {
  return {
    group_type_id: sel.group_type_id,
    all_roles: sel.all_roles,
    role_ids: sel.all_roles ? undefined : sel.role_ids,
  };
}

export function selectionsToPermissions(
  selections: GroupTypeRoleSelection[]
): GroupPermission[] {
  return selections.map(selectionToPermission);
}

export function isValidGroupTypeRoleSelection(
  sel: GroupTypeRoleSelection
): boolean {
  return sel.all_roles || (sel.role_ids?.length ?? 0) > 0;
}

export function filterValidSelections(
  selections: GroupTypeRoleSelection[]
): GroupTypeRoleSelection[] {
  return selections.filter(isValidGroupTypeRoleSelection);
}

export function isValidGroupPermission(perm: GroupPermission): boolean {
  return perm.all_roles || (perm.role_ids?.length ?? 0) > 0;
}

export function permissionsToSelections(
  permissions: GroupPermission[],
  scopeByGroupTypeId: Map<string, GroupScope>
): GroupTypeRoleSelection[] {
  return permissions.map((perm) => {
    const scope = scopeByGroupTypeId.get(perm.group_type_id) ?? 'international';
    return permissionToSelection(perm, scope);
  });
}

export function permissionsToBulkGrants(
  permissions: GroupPermission[]
): BulkPermissionGrant[] {
  return permissions.filter(isValidGroupPermission).map((p) => ({
    group_type_id: p.group_type_id,
    all_roles: p.all_roles,
    role_ids: p.all_roles ? undefined : p.role_ids,
  }));
}
